export { renderToastFooter_unstable as renderToastFooter } from '@fluentui/react-toast';
